var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import clsx from "clsx";
import { forwardRef } from "react";
import { useStyles } from "./ui_typography.css";
export const UiTypography = forwardRef((_a, ref) => {
    var { className, ellipsis, gutterBottom, gutterBottomSize = "sm", oneline, overflowWrap, wordBreak } = _a, props = __rest(_a, ["className", "ellipsis", "gutterBottom", "gutterBottomSize", "oneline", "overflowWrap", "wordBreak"]);
    const classes = useStyles({
        ellipsis,
        gutterBottom,
        gutterBottomSize,
        oneline,
        overflowWrap,
        wordBreak,
    });
    return (_jsx(Typography, Object.assign({ ref: ref, className: clsx(className, classes.ui_typography) }, props)));
});
//# sourceMappingURL=ui_typography.js.map